// /// 顶部 --- 统计数据
// export const totalConfig = {
//     "MN总品项": "43%",
//     "YLD总品项": "74%",
//     "JLB总品项": "1.0%",
//     "YL总品项": "1.0%"
//   }
  
  /// ----
  export const tableDataArr1 = {
    "product": ["MA店","20店","CVS","全店通","现代"],
      "已拜访": [0,0,0,23956,8516],
      // "未拜访": [45515,18057,8777,134968,5670],
  }
  
  export const tableDataArr2 = {
    "product": ["北京","东北","华北","华东","华南","华中","闽赣","山东","上海","西北","西南","豫皖"],
    "已拜访": [757,4125,1927,5218,3806,3268,2232,1530,853,3857,2642,2257],
    // "未拜访": [2059,19716,12122,19638,22279,26563,13478,7805,3605,13420,18640,12698],
    }
  
  export const tableDimensionArr = ["product", "已拜访"]
  
  ///
  export const modernChartDataArr = [
    {
      "type": "bar",
      "barWidth": "70%",
      "stack": "vistors",
      "label": {
        "normal": {
          "show": true,
          "color": "black",
          "fontSize": 10,
          "position": "inside"
        }
      },
      "animationDuration": 2800,
      "animationEasing": "cubicInOut"
    },
    // {
    //   "type": "bar",
    //   "barWidth": "70%",
    //   "stack": "vistors",
    //   "label": {
    //     "normal": {
    //       "show": true,
    //       "color": "black",
    //       "fontSize": 10,
    //       "position": "inside"
    //     }
    //   },
    //   "animationDuration": 2800,
    //   "animationEasing": "cubicInOut"
    // },
    
  ]
  
  
  


// WEBPACK FOOTER //
// ./src/components/kpi/config/ToTerminal.js